import { NavigateOptions, To, useNavigate, NavigateFunction } from 'react-router-dom';

import { useGlobalFormState } from '../context/GlobalFormStateContext';
import { useGlobalNavigatePrompt } from '../context/GlobalNavigatePromptContext';

function useNavigateWithConfirm(): NavigateFunction | (() => void) {
  const { isDirty, isSystemUser } = useGlobalFormState();
  const { setIsPromptOpen, setNavigateTo, setNavigateOptions } = useGlobalNavigatePrompt();

  const navigate = useNavigate();

  // eslint-disable-next-line consistent-return
  return (to: To | number | null | undefined, options: NavigateOptions = {}): void => {
    if (to !== null && to !== undefined) {
      // TODO: NavigationFunction can be overloaded as a delta
      //  to move back/forward x number of pages, handle this?
      if (typeof to !== 'number') {
        const preventNavigation = isDirty || isSystemUser;
        if (preventNavigation) {
          setIsPromptOpen(true);
          setNavigateTo(to);
          setNavigateOptions(options);
        } else {
          return navigate(to, options);
        }
      }
    }
  };
}

export default useNavigateWithConfirm;
